import { Row, Col, Card, Descriptions, Timeline, Button, Select } from "antd";
import { useEffect, useState } from "react";
import {
  ArrowLeftOutlined,
  SmileOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { getDeviceLogs, getDeviceTempGraph } from "../api/devices";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Chart from "react-apexcharts";

function DeviceGraphs() {
  const navigate = useNavigate();
  const [deviceID, setDeviceID] = useState(
    window.history.state?.usr?.device_id
  );
  const [deviceLogs, setDeviceLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [interval, setInterval] = useState("1h"); // Default interval
  const [startDate, setStartDate] = useState(
    moment().subtract(1, "days").format("YYYY-MM-DD")
  ); // Default start date
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD")); // Default end date

  useEffect(() => {
    if (deviceID) {
      _getDeviceLogs(deviceID);
    }
  }, [deviceID, interval, startDate, endDate]); // Add startDate and endDate to dependencies

  const _getDeviceLogs = async (id) => {
    setLoading(true); // Show loading state
    const start_date = moment().subtract(1, "days").format("YYYY-MM-DD"); // Example: 1 day ago
    const end_date = moment().format("YYYY-MM-DD"); // Example: today

    try {
      const res = await getDeviceTempGraph(id, {
        start_date,
        end_date,
        interval,
      }); // Pass parameters to API
      if (res?.statusCode === 200) {
        // Sort the logs by time_interval in ascending order
        const sortedLogs = res.data.sort(
          (a, b) => new Date(a.time_interval) - new Date(b.time_interval)
        );
        setDeviceLogs(sortedLogs); // Store the sorted data
      } else {
        console.error("Failed to fetch device logs");
      }
    } catch (e) {
      console.error("Error fetching device logs", e);
    }
    setLoading(false); // Hide loading state
  };

  const handleIntervalChange = (value) => {
    setInterval(value); // Update the selected interval
  };

  const _goBack = () => {
    navigate(-1);
  };

  const handleDateChange = () => {
    if (deviceID) {
      _getDeviceLogs(deviceID); // Fetch logs again when dates change
    }
  };

  const chartOptions = {
    chart: {
      id: "temperature-chart",
    },
    xaxis: {
      categories: deviceLogs.map(
        (log) => moment(log.time_interval).format("MMM DD HH:mm") // Format to include date and time
      ), // Use time_interval for x-axis
    },
  };

  const chartSeries = [
    {
      name: "Average Temperature",
      data: deviceLogs.map((log) => Number(log.avg_temperature.toFixed(0))), // Convert to a number after fixing to 0 decimal places
    },
  ];

  return (
    <div className="tabled">
      <div
        style={{ paddingTop: 10, paddingBottom: 10, cursor: "pointer" }}
        onClick={_goBack}
      >
        <ArrowLeftOutlined /> Back
      </div>

      <Row gutter={[24, 0]}>
        <Col xs={24} xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title={"Device Temperature Graph"}
          >
            <div className="ant-list-box m-25 px-2">
              <Descriptions bordered>
                <Descriptions.Item label="ID">{deviceID}</Descriptions.Item>
              </Descriptions>
            </div>
            <div style={{ marginBottom: 20, marginLeft: 20 }}>
              <input
                type="date"
                value={startDate}
                onChange={(e) => {
                  setStartDate(e.target.value);
                  handleDateChange(); // Fetch logs on date change
                }}
              />
              <input
                type="date"
                value={endDate}
                onChange={(e) => {
                  setEndDate(e.target.value);
                  handleDateChange(); // Fetch logs on date change
                }}
                style={{ marginLeft: 10 }}
              />
              <Select
                defaultValue={interval}
                onChange={handleIntervalChange}
                style={{ width: 120, marginBottom: 20, marginLeft: 10 }}
              >
                <Select.Option value="5m">5 Minutes</Select.Option>
                <Select.Option value="10m">10 Minutes</Select.Option>
                <Select.Option value="15m">15 Minutes</Select.Option>
                <Select.Option value="30m">30 Minutes</Select.Option>
                <Select.Option value="1h">1 Hour</Select.Option>
                <Select.Option value="4h">4 Hours</Select.Option>
              </Select>
            </div>

            <div className="px-2 m-25">
              <Chart
                options={chartOptions}
                series={chartSeries}
                type="line"
                height={350}
              />
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default DeviceGraphs;
